<template>
  <div>
    <v-row justify="center">
      <v-col lg="10" sm="12">
        <v-card elevation="2" v-if="Object.keys(list).length != 0">
          <v-card-title class="text-h5">
              <div>Персональные данные</div>
              <v-spacer></v-spacer>
              <v-btn outlined small rounded v-if="!isEdit" :loading="isLoading" @click.stop="setEditMode" style="text-align: right;">Редактировать</v-btn>
              <v-btn outlined small rounded v-if="isEdit" :loading="isLoading" @click.stop="submitChange" style="text-align: right;">Сохранить</v-btn>
          </v-card-title>
          <v-card-text class="request-data card-text-custom pt-4">
            <v-form class="form" ref="profileForm">
              <template v-for="(item, itemKey) in list">
                <v-col v-if="item.is_visible" class="item-row" lg="12" :key="itemKey">
                  <v-row v-if="!isEdit" style="font-size: 16px;">
                    <v-col md="5"><b>{{ item.name }}:</b></v-col>
                    <v-col md="7">
                      <template v-if="item.type == 'text' || item.type == 'number' || item.type == 'email' || item.type == 'date'">
                        {{ item.value }}
                      </template>
                      <template v-else-if="item.type == 'base64'">
                        <a :href="item.value" target="_blank"><v-img width="150px" :src="item.value" aspect-ratio="1.5" /></a>
                      </template>
                      <template v-else>
                        {{ item.value.name }}
                      </template>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col>
                      <v-text-field
                        v-if="item.type == 'text' || item.type == 'number' || item.type == 'email'"
                        v-model="editData[itemKey]"
                        :error-messages="fieldsError[itemKey]"
                        :label="item.name"
                        :type="item.type"
                        :rules="[v => !item.required || !!v || 'Обязательное поле']"
                        :disabled="!item.can_change">
                      </v-text-field>
                      <v-menu
                        v-else-if="item.type == 'date'"
                        v-model="item.date_picker"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editData[itemKey]"
                            :error-messages="fieldsError[itemKey]"
                            :label="item.name"
                            readonly
                            prepend-icon="mdi-calendar"
                            :rules="[v => !item.required || !!v || 'Обязательное поле']"
                            :disabled="!item.can_change"
                            required
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker locale="ru-RU" v-model="editData[itemKey]"></v-date-picker>
                      </v-menu>
                      <template v-else-if="item.type == 'reference'">
                        <template>
                          <v-autocomplete
                            v-model="editData[itemKey]"
                            :error-messages="fieldsError[itemKey]"
                            :items="reference[item.reference_name]"
                            item-text="name"
                            :item-value="item.reference_id" 
                            :label="item.name"
                            :disabled="!item.can_change"
                            :key="reference[item.reference_name] + updateCount"
                            :rules="[v => !item.required || Object.keys(v).length != 0 || 'Обязательное поле']"
                            >
                          </v-autocomplete>
                        </template>
                      </template>
                      <template v-else-if="item.type == 'base64'">
                        <v-file-input
                          :label="item.name" 
                          accept="image/*" 
                          :disabled="!item.can_change"
                          :error-messages="fieldsError[itemKey]"
                          :rules="[v => !item.required || !!v || 'Обязательное поле', v => !v || v.size < 10000000 || 'Размер файла не должен превышать 10 Мб']" 
                          @change="toBase64($event, itemKey)"
                          required>
                        </v-file-input>
                      </template>
                    </v-col>
                  </v-row>
                </v-col>
              </template>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>


<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        isLoading: false,
        list: {},
        reference: {},
        updateCount: 0,
        isEdit: false,
        editData: {},
        originalData: {},
        fieldsError: {}
      }
    },
    mounted() {
      this.getInfo()
    },
    methods: {
      async getInfo() {
        this.isLoading = true;
        await axios.get('https://api.portfolio.edus.kz/v1/ru/detail/profile', {}).then((response) => {
          this.list = response.data;
          let userInfo = this.$store.getters.getUserInfo;
          if (userInfo.userAvatar != response.data.avatar.value) {
            userInfo.userAvatar = response.data.avatar.value;
            //this.$forceUpdate();
          }

          if(userInfo.userName != response.data.surname.value+' '+response.data.name.value) {
            userInfo.userName = response.data.surname.value+' '+response.data.name.value;
          }

          if(userInfo.userGeneralExperience != response.data.general_experience.value) {
            userInfo.userGeneralExperience = response.data.general_experience.value;
          }

          if(userInfo.userProfessionalExperience != response.data.professional_experience.value) {
            userInfo.userProfessionalExperience = response.data.professional_experience.value;
          }
          
          this.$store.commit('setUserInfo', userInfo);
          this.isLoading = false;
        }).catch(err => { 
          console.log(err)
        })
      },

      async getReferences() {
        this.isLoading = true;
        for(let key in this.list) {
          let item = this.list[key];
          if(item.type == 'reference' && item.can_change && !this.reference[item.reference_name]) {
            await axios.get('https://api.portfolio.edus.kz/v1/ru/reference/'+item.reference_name).then((response) => {
              this.reference[item.reference_name] = response.data;
              this.updateCount++;
            }).catch(err => {
              console.log(err)
            });
          }
        }
        this.isLoading = false;
      },
      toBase64(file, key) { // TODO
          this.editData[key] = null;
          if(file) {
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = () => {
                  let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
                  if ((encoded.length % 4) > 0) {
                      encoded += '='.repeat(4 - (encoded.length % 4));
                  }
                  this.editData[key] = encoded;
              };
          }
      },
      setEditMode() {
        this.editData = {};
        this.fieldsError = {};
        this.originalData = {};

        for (let [headerKey, headerItem] of Object.entries(this.list)) {
          if(!headerItem.values) {
              if(headerItem.type == 'reference') {
                this.editData[headerKey] = headerItem.value[headerItem.reference_id];
              } else {
                this.editData[headerKey] = headerItem.value;
              }
          } else {
              this.editData[headerKey] = headerItem.values.map(el => el[headerItem.tag_id]);
          }
        }
        this.originalData = Object.assign({}, this.editData);
        this.getReferences().then(() => this.isEdit = true);
      },
      async submitChange() {
        if(this.$refs.profileForm.validate()) {
            this.isLoading = true;
            let editData = this.getChanges(this.originalData, this.editData);

            if(Object.keys(editData).length != 0) {
                await this.$http.patch('https://api.portfolio.edus.kz/v1/ru/detail/profile', editData).then(() => {
                    this.getInfo();
                    this.isEdit = false;
                }).catch(err => {
                  if (err.response.status === 400 && err.response.data.fields) {
                    this.fieldsError = err.response.data.fields;
                  }
                });  
            } else {
                this.isEdit = false;
            }
            this.isLoading = false;
        }


      },
      getChanges(originalData, newData) {
          let changedData = {};
          for (let key in originalData) {
              if(originalData[key] != newData[key]) {
                  changedData[key] = newData[key];
              }
          }
          return changedData;
      }
    },
    components: { }
  }
</script>

<style>
  .personal-image {
    text-align: center;
  }
  .personal-image input[type="file"] {
    display: none;
  }
  .personal-figure {
    position: relative;
    width: 120px;
    height: 120px;
  }
  .personal-avatar {
    cursor: pointer;
    width: 120px;
    height: 120px;
    box-sizing: border-box;
    border-radius: 100%;
    border: 2px solid transparent;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
    transition: all ease-in-out .3s;
  }
  .personal-avatar:hover {
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  }
  .personal-figcaption {
    cursor: pointer;
    position: absolute;
    top: 0px;
    width: inherit;
    height: inherit;
    border-radius: 100%;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0);
    transition: all ease-in-out .3s;
  }
  .personal-figcaption:hover {
    opacity: 1;
    background-color: rgba(0, 0, 0, .5);
  }
  .personal-figcaption > img {
    margin-top: 32.5px;
    width: 50px;
    height: 50px;
  }
</style>

